(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paragon-events-latest"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.paragon-events-latest__video').forEach((video) => {
    video.setAttribute('playsinline', '');
    video.muted = true;
    video.play().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paragon-events-video-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.paragon-events-video-banner__video').forEach((video) => {
    video.setAttribute('playsinline', '');
    video.muted = true;
    const playVideo = () => {
      video.play().catch(() => {});
    };
    if (video.readyState >= 2) playVideo();
    else video.addEventListener('loadeddata', playVideo, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paragon-manufacturing-build"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.paragon-mfg-build__video').forEach((video) => {
    video.setAttribute('playsinline', '');
    video.muted = true;
    video.play().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();
})();
